import styled from 'styled-components'

export const PageContent = styled.div`
  @media (max-width: 1000px) {
    padding: 0 5px 5px 5px;
  }
  padding: 0 47px 47px 47px;
`
